<input type="text"
       matInput
       [placeholder]="placeholder() || standardPlaceholder"
       [formControl]="skjemakontroll()"
       [matAutocomplete]="tidssonerAutoComp"
       data-testid="tidssone-felt">
<!-- merk at vi ikke kan sett requireSelection="false" da dette fører til at filtreringsmekanismen ikke virker (valueChanges emitter ikke) -->
<mat-autocomplete autoActiveFirstOption="true" panelWidth="200px" #tidssonerAutoComp="matAutocomplete">
  @for (tidssone of filtrerteTidssoner | async; track tidssone) {
    <mat-option [value]="tidssone">{{tidssone}}</mat-option>
  }
</mat-autocomplete>
